import Moment from "moment";

export const formatDate = (date, format = "DD-MMM YYYY") => {
    if(date) {
        return Moment(date).format(format);
    }

    return "None";
}

export const isDelayed = (date) => {
    return Moment(Moment().format("YYYY-MM-DD")).isAfter(Moment(date).format("YYYY-MM-DD"));
}

export const isBefore = (prev, next) => {
    return Moment(Moment(prev).format("YYYY-MM-DD")).isBefore(Moment(next).format("YYYY-MM-DD"));
}

export const daysRemaining = (date) => {
    return Moment(Moment(date).format("YYYY-MM-DD")).diff(Moment().format("YYYY-MM-DD"), 'days');
}